import { render } from "./PleaseVerifyUserModal.vue?vue&type=template&id=7a60174f"
import script from "./PleaseVerifyUserModal.vue?vue&type=script&lang=js"
export * from "./PleaseVerifyUserModal.vue?vue&type=script&lang=js"

import "./PleaseVerifyUserModal.vue?vue&type=style&index=0&id=7a60174f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__